import * as actionTypes from "./actionTypes";
import { firebase } from "../../firebase/index";
import { collections, constants } from "../../firebase/firestoreNameSpaces";
import { AlertTitle } from "@material-ui/lab";
import axios from "axios";

let url = constants.nodeserver;

export const resetLoadMoreBookings = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BOOKINGS_CONTROLS,
      payload: { leadsexhausted: false, lastDoc: null },
    });
  };
};
//Displaying Ongoing and Completed Orders under same tab i.e OngoingOrder.
//For OngoingOrder No LoadMore i.e fetching all Ongoing Orders
//LoadMore actually applies to the completedorders
export const onFetchOngoingUserBookings = (userId) => {
  return (dispatch, getState) => {
    if (!userId) {
      return null;
    }
    dispatch({
      type: actionTypes.BOOKINGS_CONTROLS,
      payload: { ongoingBtnLoading: true },
    });
    let limit = getState().bookings.limit;
    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("userId", "==", userId)
      // .where("orderStatus", "in", ["created"])
      .where("paymentStatus", "==", "confirmed")
      .orderBy("timestamp", "desc")
      .get()
      .then((snapshot) => {
        let ongoingOrders = [];
        let lastDoc = snapshot.docs[snapshot.size - 1];
        snapshot.forEach((doc, index) => {
          // console.log(doc.data())

          ongoingOrders.push(doc.data());
        });

        // let or =  ongoingOrders[0];
        // or.products.pop();
        // ongoingOrders.pop();
        // ongoingOrders.push(or)

        if (snapshot.size < limit) {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              ongoingBtnLoading: false,
              ongoingOrders: ongoingOrders,
              lastDoc: lastDoc,
              leadsexhausted: true,
            },
          });
        } else {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              ongoingBtnLoading: false,
              ongoingOrders: ongoingOrders,
              lastDoc: lastDoc,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: { ongoingOrders: [], ongoingBtnLoading: false },
        });
        // console.log(err)
        return alert(err);
      });
  };
};

export const onFetchCompletedUserBookings = (userId) => {
  return (dispatch, getState) => {
    // if(!userId){
    //   return null
    // }
    dispatch({
      type: actionTypes.BOOKINGS_CONTROLS,
      payload: { completedBtnLoading: true },
    });
    let limit = getState().bookings.limit;
    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("userId", "==", userId)
      .where("orderStatus", "==", "completed")
      .where("paymentStatus", "==", "confirmed")
      .orderBy("timestamp", "desc")
      .limit(limit)
      .get()
      .then((snapshot) => {
        let completedOrders = [];
        let lastDoc = snapshot.docs[snapshot.size - 1];
        snapshot.forEach((order) => {
          completedOrders.push(order.data());
        });
        if (snapshot.size < limit) {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              completedBtnLoading: false,
              completedOrders: completedOrders,
              lastDoc: lastDoc,
              leadsexhausted: true,
            },
          });
        } else {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              completedBtnLoading: false,
              completedOrders: completedOrders,
              lastDoc: lastDoc,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: {
            completedBtnLoading: false,
            completedOrders: [],
          },
        });
        return alert(err);
      });
  };
};

export const onFetchCancelledUserBookings = (userId) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.BOOKINGS_CONTROLS,
      payload: { cancelBtnLoading: true },
    });
    let limit = getState().bookings.limit;
    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("userId", "==", userId)
      .where("orderStatus.Status", "array-contains-any", ["RETURNED", "RTO"])
      .where("paymentStatus", "==", "confirmed")
      .orderBy("timestamp", "desc")
      .limit(limit)
      .get()
      .then((snapshot) => {
        let cancelledOrders = [];
        let lastDoc = snapshot.docs[snapshot.size - 1];
        snapshot.forEach((order) => {
          cancelledOrders.push(order.data());
        });
        // console.log(cancelledOrders);
        if (snapshot.size < limit) {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              cancelBtnLoading: false,
              cancelledOrders: cancelledOrders,
              lastDoc: lastDoc,
              leadsexhausted: true,
            },
          });
        } else {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              cancelBtnLoading: false,
              cancelledOrders: cancelledOrders,
              lastDoc: lastDoc,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: {
            cancelBtnLoading: false,
            cancelledOrders: [],
          },
        });
        return alert(err);
      });
  };
};

export const onLoadMoreCancelledOrders = (
  userId,
  leadsexhausted,
  lastDoc,
  limit
) => {
  return (dispatch, getState) => {
    if (leadsexhausted) {
      // return alert("Leads Exhausted");
      return true;
    }

    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("userId", "==", userId)
      .where("orderStatus.Status", "array-contains-any", ["RETURNED", "RTO"])
      .where("paymentStatus", "==", "confirmed")
      .orderBy("timestamp", "desc")
      .startAfter(lastDoc)
      .limit(limit)
      .get()
      .then((snapshot) => {
        let cancelledOrders = getState().bookings.cancelledOrders;
        snapshot.forEach((order) => {
          cancelledOrders.push(order.data());
        });
        lastDoc = snapshot.docs[snapshot.size - 1];
        if (snapshot.size) {
          if (snapshot.size < limit) {
            dispatch({
              type: actionTypes.BOOKINGS_CONTROLS,
              payload: {
                cancelBtnLoading: false,
                cancelledOrders: cancelledOrders,
                lastDoc: lastDoc,
                leadsexhausted: true,
              },
            });
          } else {
            dispatch({
              type: actionTypes.BOOKINGS_CONTROLS,
              payload: {
                cancelBtnLoading: false,
                cancelledOrders: cancelledOrders,
                lastDoc: lastDoc,
              },
            });
          }
        } else {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              cancelBtnLoading: false,
              leadsexhausted: true,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: {
            cancelBtnLoading: false,
          },
        });
        return alert(err);
      });
  };
};
//Currenty using for loading ongoingOrders+completed Order
export const LoadMoreCompletedOrders = (
  userId,
  leadsexhausted,
  lastDoc,
  limit
) => {
  return (dispatch, getState) => {
    // let {leadsexhausted,lastDoc,limit} = getState().bookings;

    if (leadsexhausted) {
      // return alert("Leads Exhausted");
      return true;
    }

    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("userId", "==", userId)
      // .where("orderStatus", "==", "completed")
      .where("paymentStatus", "==", "confirmed")
      .orderBy("timestamp", "desc")
      .startAfter(lastDoc)
      .limit(limit)
      .get()
      .then((snapshot) => {
        let ongoingOrders = getState().bookings.ongoingOrders;
        snapshot.forEach((order) => {
          ongoingOrders.push(order.data());
        });
        lastDoc = snapshot.docs[snapshot.size - 1];
        if (snapshot.size) {
          if (snapshot.size < limit) {
            dispatch({
              type: actionTypes.BOOKINGS_CONTROLS,
              payload: {
                ongoingBtnLoading: false,
                ongoingOrders: ongoingOrders,
                lastDoc: lastDoc,
                leadsexhausted: true,
              },
            });
          } else {
            dispatch({
              type: actionTypes.BOOKINGS_CONTROLS,
              payload: {
                ongoingBtnLoading: false,
                ongoingOrders: ongoingOrders,
                lastDoc: lastDoc,
              },
            });
          }
        } else {
          dispatch({
            type: actionTypes.BOOKINGS_CONTROLS,
            payload: {
              ongoingBtnLoading: false,
              leadsexhausted: true,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: {
            ongoingBtnLoading: false,
          },
        });
        return alert(err);
      });
  };
};

export const onCancelOrder = (order, product, waybill) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BOOKINGS_CONTROLS,
      payload: { cancelOrderLoading: true },
    });
    //cancel k baad page refresh kardena
    // let db = firebase.firestore();
    // db.collection(collections.ORDERS)
    //   .doc(orderId)
    //   .update({
    //     orderStatus: "cancelled",
    //   })

    // axios.post(`${url}/cancelOrder`,{waybill,product})
    firebase
      .functions()
      .httpsCallable("cancelOrder")({ waybill, product })
      .then((response) => {
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: { cancelOrderLoading: false },
        });
        alert(response.data);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: { cancelOrderLoading: false },
        });
        alert(err);
      });
  };
};

export const returnOrder = (order, product, waybill) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BOOKINGS_CONTROLS,
      payload: { cancelOrderLoading: true },
    });

    // axios.post(`${url}/returnOrder`,{order, product, waybill})
    firebase
      .functions()
      .httpsCallable("returnOrder")({ order, product, waybill })
      .then((response) => {
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: { cancelOrderLoading: false },
        });
        alert(response.data);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: { cancelOrderLoading: false },
        });
        alert(err);
      });
  };
};

export const cancelReturn = (order, product, waybill) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BOOKINGS_CONTROLS,
      payload: { cancelOrderLoading: true },
    });
    //cancel k baad page refresh kardena
    // let db = firebase.firestore();
    // db.collection(collections.ORDERS)
    //   .doc(orderId)
    //   .update({
    //     orderStatus: "cancelled",
    //   })

    // axios.post(`${url}/cancelReturn`,{waybill,product})
    firebase
      .functions()
      .httpsCallable("cancelReturn")({ waybill, product })
      .then((response) => {
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: { cancelOrderLoading: false },
        });
        alert(response.data);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.BOOKINGS_CONTROLS,
          payload: { cancelOrderLoading: false },
        });
        alert(err);
      });
  };
};

// let db =  firebase.firestore();
// db.collection(collections.K5METADATA).doc("test")
// .set({
//  status:firebase.firestore.FieldValue.arrayRemove()
// },{merge:true}).then(()=>{})
// return true;
